<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      company: this.$store.getters["company/getCompany"] || null,
    };
  },
  methods: {
    go() {
      if (this.company) {
        window.location.href = `/forms/estandares/${this.company.id}/acta-conformacion1.1.6`;
      }
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <div>
        <div class="card-body">
          <div class="row align-middle text-center">
            <div class="col-sm-12 col-md-6 text-md-right text-sm-center">
              <img
                src="@/assets/images/business.png"
                id="tooltip"
                height="100%"
                width="50%"
                alt="business"
              />
            </div>
            <div class="col-sm-12 col-md-6 align-middle text-left pt-3">
              <h2>Antes que nada,</h2>
              <h5 v-if="!text">
                Se necesita que se conforme al menos un Copasst
                {{ company.social_reason }} dentro del sistema.
              </h5>
              <h5 v-else>
                {{ text }}
              </h5>
              <button v-if="company" class="btn btn-primary" @click="go">
                Agregar Copasst
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
